/* eslint-disable */
import { useEffect, useState } from 'react';
import { useTranslation } from '../../../locale/useTranslation';
import * as API from '../../../framework/API/api';
import { ENTITYNAME, MAM_STATUS, TRANSMISSION_STATUS } from '../../../framework/constant/constant';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { TimeCellWithOutFrames } from '../../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import RoundButton from '../../../framework/forms/helpercomponents/buttons/RoundButton';
import ContractCollectionSelection from '../../Contract/ContractCollectionSelection';
import { utility } from '../../../framework/utility/utilityProvider';
import { toast } from 'react-toastify';
import NodeTreeViewForm from '../NodeTreeView/NodeTreeViewForm';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { getter, process } from '@progress/kendo-data-query';
import { ArrayCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import MyStatusCell from '../../../components/MyStatusCell';
import { DateTimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import ManageNodeTreeViewEditPanel from './ManageNodeTreeViewEditPanel';

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

const NodeTreeViewCollection = (props) => {

    const { showTitle = true } = props;

    const lang = useTranslation();

    const [selectedNode, setSelectedNode] = useState({});
    const [mediaData, setMediaData] = useState([]);
    const [filterdMediaData, setFilterdMediaData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showAttachMedia, setShowAttachMedia] = useState(false);
    const [parentEntityName, setParentEntityName] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const defaultMediaCategory = { _id: null, Description: "All" };
    const defaultOffer = { _id: null, Title: "All" };
    const [entityName, setEntityName] = useState(null);
    const [mediaCategories, setMediaCategories] = useState([]);
    const [offers, setOffers] = useState([]);

    const [mediaCategory, setMediaCategory] = useState(defaultMediaCategory);
    const [offer, setOffer] = useState(defaultOffer);

    const [sort, setSort] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [showMultiUpdate, setShowMultiUpdate] = useState(false);
    const [mediaCountData, setMediaCountData] = useState({});


    useEffect(() => {
        loadCombo();
    }, []);

    useEffect(() => {
        loadData();
    }, [selectedNode]);

    const loadCombo = async () => {
        let mediaCategoryRes = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { Description: 1 } });
        mediaCategoryRes?.data?.unshift({ _id: null, Description: 'All' });
        setMediaCategories(mediaCategoryRes.data);

        let offerRes = await API.getDataLookup(ENTITYNAME.OFFER, { sort: { Title: 1 } });
        offerRes?.data?.unshift(defaultOffer);

        console.log(offerRes.data)
        setOffers(offerRes.data);

    }

    const loadData = async () => {

        if (!selectedNode?._id) return;

        let query = {
            nodeId: selectedNode._id,
            parentNodeId: null,
            offerId: null,
        }

        const transmissionDataRes = await API.getTransmissons(query);
        console.log(transmissionDataRes);

        setIsLoading(true);

        // const mediaRes = await API.getMediaByConentCategory({ contentCategoryId: selectedNode?._id });
        // const mediaCountContentCategory = await API.getMediaCountByContentCategory({ contentCategoryId: selectedNode?._id });
        // setMediaCountData(mediaCountContentCategory?.data);

        if (transmissionDataRes.success) {
            setMediaData(transmissionDataRes.data);
            setFilterdMediaData(transmissionDataRes.data);
        } else {
            toast.error(transmissionDataRes.message);
            setMediaData([]);
            setFilterdMediaData([]);
        }
        setIsLoading(false);
    }

    const applyFilters = (text, offer) => {
        let filtered = mediaData;

        // Apply offer filter
        if (offer._id) {
            filtered = filtered.filter((item) =>
                item?.offer?._id == offer?._id
            );
        }

        // Apply search filter
        if (text) {
            filtered = filtered.filter((item) => {
                const ep = item?.mediaEpisode || {};
                return (
                    ep.Title?.toLowerCase().includes(text) ||
                    ep.Description?.toLowerCase().includes(text) ||
                    ep.MediaCategory?.Description?.toLowerCase().includes(text) ||
                    ep.AssetId?.toString()?.toLowerCase().includes(text)
                );
            });
        }

        setFilterdMediaData(filtered);
    };

    const onSearch = (e) => {
        e.preventDefault();
        let text = e.target.value?.trim().toLowerCase();
        setSearchText(text);
        applyFilters(text, offer);
    };

    const onItemClick = (e, dataItem) => {
    
        const transmissionGridData = dataItem;

        if (e.ctrlKey || e.metaKey) {
            if (selectedItems.some(x => x?._id === transmissionGridData?._id)) {
                setSelectedItems(selectedItems.filter(x => x._id !== transmissionGridData._id));
            } else {
                setSelectedItems([...selectedItems, transmissionGridData]);
            }
        } else {
            setSelectedItems([transmissionGridData]);
        }
    };

    const onChange = (e) => {
        const { value } = e.target;
        setOffer(value);
        setSelectedItems([]);
        setSort([]);
        setShowMultiUpdate(false);
        applyFilters(searchText, value);
    };

    const MAMStatusCell = (props) => {
        const { dataItem } = props;
        const statusValue = dataItem?.mediaEpisode?.MamStatus ?? MAM_STATUS.Pending;

        let title = utility.getKeyByValue(MAM_STATUS, statusValue);
        let tileBackColor = "";
        let titleColor = "white";


        if (statusValue == MAM_STATUS.Pending) {
            tileBackColor = "#9CA3AF";
            titleColor = "#000000"; // Black
        } else if (statusValue == MAM_STATUS.Ingested) {
            tileBackColor = "#2563EB";
        } else if (statusValue == MAM_STATUS.Transcoding) {
            tileBackColor = "#F59E0B";
        } else {
            tileBackColor = "#16A34A";
        }

        return (
            <MyStatusCell {...props} title={title} titleColor={titleColor} tileBackColor={tileBackColor} />
        );
    };

    const StatusCell = (props) => {
        const { dataItem } = props;

        let title = "";
        let tileBackColor = "";

        if (dataItem?.offerLink?.Status === TRANSMISSION_STATUS.Published) {
            title = 'Published';
            tileBackColor = "#2ba666";
        } else {
            title = 'Un-Published';
            tileBackColor = "#FF0000";
        }

        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} />
        );
    };

    // Render media list
    const renderMediaList = () => {
        const FullCenter = ({ children }) => (
            <div style={{
                height: 'calc(100vh - 294px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#999',
                textAlign: 'center',
                padding: '20px'
            }}>
                {children}
            </div>
        );

        const totalCount = mediaCountData ? Object.values(mediaCountData).reduce((a, b) => a + b, 0) : 0;

        return (
            <div style={{ padding: '15px' }}>
                <div style={{
                    borderBottom: '2px solid #ddd',
                    paddingBottom: '10px',
                    marginBottom: '15px'
                }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
                            {selectedNode?._id && <>
                                <RoundButton title={lang.attach_media_button_tooltip} icon="link" onClick={() => setShowAttachMedia(true)} />
                            </>} Transmissions
                        </h3>
                        {selectedNode?.Name && (
                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                {selectedNode.Name}({totalCount})
                            </span>
                        )}
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <p style={{ margin: '5px 0 0 0', fontSize: '13px', color: '#666' }}>
                            {filterdMediaData.length} {filterdMediaData.length === 1 ? 'item' : 'items'} found
                        </p>

                        {mediaData.length > 0 &&
                            <div>
                                <label className='mr-2'>{lang.offer_label} </label>
                                <DropDownList
                                    style={{ width: (showMultiUpdate || selectedItems.length > 0) ? "120px" : "200px", marginRight: "10px" }}
                                    data={offers}
                                    dataItemKey="_id"
                                    textField="Title"
                                    value={offer}
                                    onChange={onChange}
                                    name="offer"
                                />
                                <input
                                    type="text"
                                    className="form-control form-control-sm shadow-inset-2 pt-0 pb-0"
                                    style={{ width: (showMultiUpdate || selectedItems.length > 0) ? "180px" : "270px" }}
                                    id="searchInput"
                                    placeholder={lang.search_button_text}
                                    onChange={onSearch}
                                    onFocus={(e) => {
                                        if (props.setOutSideFocus) {
                                            props.setOutSideFocus(true);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        if (props.setOutSideFocus) {
                                            props.setOutSideFocus(false);
                                        }
                                    }}
                                />
                                <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                                    <span className="input-group-text" style={{ padding: "4px 10px", fontSize: "14px" }}>
                                        <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                    </span>
                                </button>
                            </div>
                        }
                    </div>
                </div>

                <div className="media-list" style={{ display: 'grid' }}>

                    {/* LOADING */}
                    {isLoading && (
                        <Loader />
                    )}

                    {/* NOTHING SELECTED */}
                    {!isLoading && !selectedNode?._id && (
                        <FullCenter>
                            <i className="fa fa-info-circle" style={{ fontSize: '30px', marginBottom: '8px' }}></i>
                            <p>{lang.select_a_category_from_the_tree_to_view_media_message}</p>
                        </FullCenter>
                    )}

                    {/* NO MEDIA FOUND */}
                    {!isLoading && selectedNode?._id && filterdMediaData.length === 0 && (
                        <FullCenter>
                            <i className="fa fa-folder-open" style={{ fontSize: '60px', marginBottom: '8px' }}></i>
                            <p>{lang.no_media_found_for_this_category_message}</p>
                            <small>{lang.try_selecting_another_category_message}</small>
                        </FullCenter>
                    )}

                    {/* GRID VIEW */}
                    {!isLoading && selectedNode?._id && filterdMediaData.length > 0 && (
                        <Grid
                            style={{ height: 'calc(100vh - 315px)', overflow: 'auto' }}
                            resizable={true}
                            sortable={{
                                allowUnsort: true,
                                mode: 'multiple'
                            }}
                            sort={sort}
                            onSortChange={(e) => {
                                setSort(e.sort);
                            }}
                            data={process(
                                filterdMediaData.map(data => ({
                                    ...data,
                                    [SELECTED_FIELD]: selectedItems.some(selectedItem => selectedItem?._id === data?.MediaEpisode?._id)
                                })),
                                { sort: sort }
                            )}
                            selectedField={SELECTED_FIELD}
                            selectable={{
                                enabled: true,
                                mode: {
                                    value: "multiple",
                                },
                            }}
                            onSelectionChange={(event) => {
                                let rowIndex = event.startRowIndex;
                                let dataItem = event.dataItems[rowIndex];
                                onItemClick(event, dataItem);
                            }}
                            dataItemKey={DATA_ITEM_KEY}
                        >
                            {/* OLD */}
                            {/* <GridColumn field="MediaEpisode.ImageUrl" title={lang.image_column} cell={ImageCell} width="80px" /> */}
                            {/* <GridColumn field="MediaEpisode.Title" title={lang.title_column} width={"220px"} /> */}
                            {/* <GridColumn field="MediaEpisode.Description" title={lang.description_column} width={"220px"} /> */}
                            {/* <GridColumn field="MediaEpisode.MediaCategory.Description" title={lang.media_category_column} width={"130px"} /> */}
                            {/* <GridColumn field="MediaEpisode.AssetId" title={lang.assetId_column} width={"120px"} /> */}
                            {/* <GridColumn field="MediaEpisode.Duration" title={lang.duration_column} cell={TimeCellWithOutFrames} width={"120px"} /> */}

                            <GridColumn field="mediaEpisode.Title" title={lang.title_column} width={"220px"} />
                            <GridColumn field="mediaEpisode.Duration" title={lang.duration_column} cell={TimeCellWithOutFrames} width={"120px"} />
                            <GridColumn field="offer.Title" title={lang.offer_label} width={"120px"} />
                            <GridColumn field="mediaEpisode.Status" title={lang.mam_asset_status_column} cell={MAMStatusCell} width={"120px"} />
                            <GridColumn field="offerLink.Status" title={lang.transmission_status_column} cell={StatusCell} width={"120px"} />
                            <GridColumn field="offer.StartDateTime" title={lang.start_date_time_label} cell={DateTimeCell} width={"120px"} />
                            <GridColumn field="offer.EndDateTime" title={lang.end_date_time_label} cell={DateTimeCell} width={"130px"} />
                            <GridColumn field="nodes" title={lang.nodes_column} format="Name" cell={ArrayCell} width="80px" />
                            <GridColumn field="parentNode.Name" title={lang.parent_node_label} width={"120px"} />

                        </Grid>
                    )}

                </div>
            </div>
        );
    };

    const handleAttachMedia = async (dataList) => {
        let newData = utility.checkDuplicateInData(dataList, mediaData.map(x => x.MediaEpisode), "AssetId");
        if (newData?.length == 0) return;

        let res = await API.updateMediaByContentCategory({ mediaIds: newData.map(x => ({ _id: x?._id, SID: x?.SID })), entityName: parentEntityName, contentCategory: { _id: selectedNode?._id, Name: selectedNode?.Name, parent: selectedNode?.parent } });
        console.log(res);

        if (res.success) {
            setIsLoading(true);
            try {
                const mediaRes = await API.getMediaByConentCategory({
                    contentCategoryId: selectedNode._id
                });
                setMediaData(mediaRes?.data ?? []);
                setFilterdMediaData(mediaRes?.data ?? []);
            } catch (error) {
                console.error('Error reloading media:', error);
                toast.error("Failed to reload media list");
            } finally {
                setIsLoading(false);
                setShowAttachMedia(false);
                setSelectedItems([]);
                setShowMultiUpdate(false);
                setMediaCategory(defaultMediaCategory);
            }
        } else {
            toast.error(res.message);
        }
    }

    const handleSingleSelectUpdatedData = (data = {}) => {

        if (!data || Object.keys(data).length === 0) return setSelectedItems([]);

        const updateList = (list) =>
            list.map((item) =>
                item?.MediaEpisode?._id === data._id
                    ? {
                        ...item,
                        ...data?.MetaData,
                        MediaEpisode: data,
                        [SELECTED_FIELD]: !item[SELECTED_FIELD],
                    }
                    : item
            );

        setMediaData(updateList(mediaData));
        setFilterdMediaData(updateList(filterdMediaData));
    };

    const handleSelectedNode = (category) => {
        setSelectedNode(category);
        setSelectedItems([]);
        setMediaCategory(defaultMediaCategory);
        setSort([]);
    }

    const hasMediaCount = mediaCountData && Object.keys(mediaCountData)?.length > 0;

    return (
        <>
            {showTitle && (
                <h1 className="page-title txt-color-bludeDark">
                    <i
                        className="fa fa-table marlr"
                        style={{ fontSize: "20px", color: "GrayText" }}
                    ></i>
                    <span>{lang.node_browser_page_breadcrumb}</span>
                </h1>
            )}
            <div className='row' style={{ margin: 0 }}>
                <div className={(showMultiUpdate || selectedItems.length > 0) ? 'col-2' : 'col-4'}>
                    <NodeTreeViewForm height="calc(100vh - 150px)" handleSelectedNodes={handleSelectedNode} />
                </div>
                <div className={(showMultiUpdate || selectedItems.length > 0) ? 'col-6' : 'col-8'}>
                    <div style={{
                        border: '1px solid #ddd',
                        backgroundColor: '#fff',
                        borderRadius: '4px',
                        height: 'calc(100vh - 150px)',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#888 #f1f1f1'
                    }}>
                        <style>
                            {`
                                .col-8 > div::-webkit-scrollbar {
                                    width: 8px;
                                }
                                .col-8 > div::-webkit-scrollbar-track {
                                    background: #f1f1f1;
                                    border-radius: 4px;
                                }
                                .col-8 > div::-webkit-scrollbar-thumb {
                                    background: #888;
                                    border-radius: 4px;
                                }
                                .col-8 > div::-webkit-scrollbar-thumb:hover {
                                    background: #555;
                                }
                            `}
                        </style>
                        {renderMediaList()}

                        {/* footer */}
                        <div className="row" style={{ position: "sticky", bottom: 0, backgroundColor: "#3a3633", borderTop: "1px solid #dcdcdc", padding: hasMediaCount ? "8px 12px" : "17.7px 12px", fontSize: "13px" }}>
                            <div className="col-12" style={{ display: "flex", alignItems: "center", gap: "22px" }}>
                                {hasMediaCount &&
                                    Object.entries(mediaCountData).map(([label, count]) => (
                                        <div key={label} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                                            <span style={{ fontSize: "13px", color: "#ffffff", marginRight: "4px" }}>{label}</span>
                                            <span style={{ fontSize: "13px", fontWeight: "600", color: "#ffffff" }}> {count ?? 0}</span>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col'>
                    {selectedItems.length == 1 && <ManageNodeTreeViewEditPanel mainStyle={{ top: 0, height: "100%", width: "100%" }} selectedItem={selectedItems[0]} entityName={entityName} transcodeStatus={selectedItems[0]?.latestTranscodeStatus?.Description ?? 'N/A'} setGridData={(data) => handleSingleSelectUpdatedData(data?.length > 0 ? data[0] : {})} gridData={selectedItems} setSelectedItem={handleSingleSelectUpdatedData} />}
                </div>
            </div>
            {showAttachMedia && <ContractCollectionSelection addButtonTitle={lang.select_button_text} title={lang.media_library_dialog_header} setDataList={handleAttachMedia} setParentEntityName={setParentEntityName} closeForm={() => setShowAttachMedia(false)} width="50vw" isFromContentTreeViewCollection={true} />}
        </>
    );
};

export default NodeTreeViewCollection;
